import Recaptcha from './Recaptcha.component';

export type { RecaptchaRef } from './Recaptcha.component';

export default Recaptcha;
